/**
 * 获取系列坐标的中心点位置
 * @param coordinates
 * @returns
 */
export function calcCenterPoint(
  arr: { latitude: number; longitude: number }[]
): { latitude: number; longitude: number } | null {
  // 检查输入是否为数组，并且数组不为空
  if (!Array.isArray(arr) || arr.length === 0) {
    console.error("Input is not a non-empty array.");
    return null;
  }

  // 计算经纬度的最小值和最大值
  const minLongitude = Math.min(...arr.map((point) => point.longitude));
  const maxLongitude = Math.max(...arr.map((point) => point.longitude));
  const minLatitude = Math.min(...arr.map((point) => point.latitude));
  const maxLatitude = Math.max(...arr.map((point) => point.latitude));

  // 计算中心点的经纬度
  const centerLongitude = (minLongitude + maxLongitude) / 2;
  const centerLatitude = (minLatitude + maxLatitude) / 2;

  console.log("RETURN: ", {
    latitude: centerLatitude,
    longitude: centerLongitude,
  })
  // 返回中心点经纬度
  return {
    latitude: centerLatitude,
    longitude: centerLongitude,
  };
}

export const calcBestBounds = (
  coordinates: { latitude: number; longitude: number }[],
  mapWidth: number,
  mapHeight: number
): number => {
  if (coordinates.length === 0) {
    return 10;
  }

  // 计算最佳缩放级别
  const bounds = coordinates.reduce(
    (acc, curr) => {
      return [
        Math.min(acc[0], curr.latitude),
        Math.min(acc[1], curr.longitude),
        Math.max(acc[2], curr.latitude),
        Math.max(acc[3], curr.longitude),
      ];
    },
    [Infinity, Infinity, -Infinity, -Infinity]
  );

  const longitudeZoom = Math.log2((360 * (mapWidth / 512)) / (bounds[2] - bounds[0]));
  const latitudeZoom = Math.log2((180 * (mapHeight / 512)) / (bounds[3] - bounds[1]));

  // 取两个方向上的较小缩放级别作为最终缩放级别
  const zoom = Math.min(longitudeZoom, latitudeZoom);

  return zoom;
};
